const GenderData = [
  { id: "male", label: "Male" },
  { id: "female", label: "Female" },
];

export default GenderData;
